export const SUB_CONTENT_SCROLL_ELEMENT = 'sub-content';
export const EMBEDDED_CONTENT_SCROLL_ELEMENT = 'sitegen-content-wrapper';
export const SCROLL_TOP_X = 0;
export const SCROLL_TOP_Y = 0;
